import Rte from './Rte'

const RteItem = ({ blok, ...props }) => {
  const { text } = blok ?? {}

  return <Rte content={text} {...props} />
}
export default RteItem
